import { Sidebar, SidebarContent, SidebarHeader, SidebarRail } from '@/shared/components/ui/sidebar'
import React from 'react'
import BrandTitle from '@/components/custom/brand'
import { MainNavMenu } from '@/components/nav-main'
import { Separator } from '@/shared/components/ui/separator'
import { useLocation, useParams } from 'react-router-dom'
import { useWorkspace } from '@/features/workspace/stores/workspace.store'
import { workspaceModules } from './workspace-modules'
import {
    NavItemsSimple,
    NavItemsSimpleComponentProps,
    NavItemsSimpleProps
} from '@/components/custom/nav-Items-simple'
import { NavUserCard } from '@/components/custom/nav-user-card'
import { SidebarUsageWidget } from '@/components/custom/sidebar-usage-widget'

const workspaceData: NavItemsSimpleComponentProps = {
    header: {
        title: 'Workspace',
        routePattern: '/workspace/[project_id]/',
    },
    navItems: Object.entries(workspaceModules).map(([_, module]) => {
        return module as unknown as NavItemsSimpleProps
    }),
}

type WorkspaceSidebarScaffoldProps = React.ComponentProps<typeof Sidebar> & {
    children?: React.ReactNode
}

export function WorkspaceSidebarScaffold({ children, ...props }: WorkspaceSidebarScaffoldProps) {
    const location = useLocation()
    const pathname = location.pathname
    const { project_id } = useParams()
    const { project } = useWorkspace()

    return (
        <Sidebar className="border-r-0" {...props}>
            <SidebarHeader>
                <BrandTitle />
                <MainNavMenu />
            </SidebarHeader>
            <Separator />
            <SidebarContent>
                <h1 className="text-left text-lg font-semibold mt-5 mx-4">{project?.title}</h1>

                {project_id && (
                    <NavItemsSimple
                        {...workspaceData}
                        url_params={{ project_id: project_id!.toString() }}
                    />
                )}

                {/* Render any passed children */}
                {children}
                <div className="mt-auto">
                    <SidebarUsageWidget />
                    <NavUserCard />
                </div>
            </SidebarContent>
            <SidebarRail />
        </Sidebar>
    )
}

export default WorkspaceSidebarScaffold
